var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 35,
    viewBox: "0 0 140 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3374 23.7763C1.3374 23.7763 6.74968 22.9833 12.9031 24.8884C24.6066 28.5118 25.2742 21.8765 29.614 18.6771C33.5844 15.75 36.8727 17.5359 41.2934 21.1155C44.5539 23.7556 49.3057 28.1873 54.2267 27.4739C58.725 26.8217 61.9139 21.6239 68.149 20.3021C73.0907 19.2544 77.1067 22.1326 82.7971 21.1155C90.5166 19.7357 93.9647 11.6128 99.4819 11.6128C106.291 11.6128 111.085 4.74268 117.28 4.74268C123.438 4.74268 124.274 8.78247 131.01 11.6128C136.16 13.7766 138.638 11.6128 138.638 11.6128V34.7995H1.3374V23.7763Z",
    fill: "url(#paint0_linear_358_8013)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3374 20.1749C1.3374 20.1749 6.74968 19.3933 12.9031 21.2708C24.6066 24.8418 25.2742 18.3026 29.614 15.1495C33.5844 12.2647 36.8727 14.0248 41.2934 17.5526C44.5539 20.1545 49.3057 24.5221 54.2267 23.8189C58.725 23.1762 61.9139 18.0537 68.149 16.7509C73.0907 15.7184 77.1067 18.555 82.7971 17.5526C90.5166 16.1928 93.9647 8.18742 99.4819 8.18742C106.291 8.18742 111.085 1.40039 117.28 1.40039C123.438 1.40039 123.765 5.39807 130.502 8.18742C135.651 10.3199 138.638 8.18742 138.638 8.18742",
    stroke: "#1B59F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_358_8013",
    x1: 26.1512,
    y1: 19.9937,
    x2: 26.1512,
    y2: 34.7995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B59F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.50a76757f4f24dc53712eeb916658ddd.svg";
export { ForwardRef as ReactComponent };